import { type ScopedPermissions } from '@air/api';

import { canCreateCanvasInBoard } from '~/utils/permissions/boardPermissions';
import { canCreateCanvasInLibrary } from '~/utils/permissions/libraryPermissions';
import { canCreateCanvasInWorkspace } from '~/utils/permissions/workspacePermissions';

export type CanCreateCanvasInCurrentLocationParams = {
  boardId: string | undefined;
  boardPermissions: ScopedPermissions | undefined;
  libraryId: string | undefined;
  libraryPermissions: ScopedPermissions | undefined;
  workspacePermissions: ScopedPermissions | undefined;
};

/**
 * Draft canvases inherit the board or library being browsed, so workspace create
 * rights must not show create affordances in a location the user cannot create in
 * (e.g. a library Commenter who can still create canvases in All Content).
 */
export const canCreateCanvasInCurrentLocation = ({
  boardId,
  boardPermissions,
  libraryId,
  libraryPermissions,
  workspacePermissions,
}: CanCreateCanvasInCurrentLocationParams) => {
  if (boardId) {
    return canCreateCanvasInBoard(boardPermissions);
  }

  if (libraryId) {
    return canCreateCanvasInLibrary(libraryPermissions);
  }

  return canCreateCanvasInWorkspace(workspacePermissions);
};
